import React, { useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import ReactMarkdown from 'react-markdown';
//import markdownContent from './AboutMarkdown.txt';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '32px',
        '& .markdown-body a, & a': {
            color: '#4CC48A', // Bright green that matches the site theme
            textDecoration: 'underline',
            '&:hover': {
                color: '#7EDAA9', // Lighter green on hover
            },
            '&:active': {
                color: '#3AA371', // Slightly darker when clicked
            }
        },
        '& h3': {
            marginBottom: '16px',
        }
    }
});

const About: React.FC = () => {
    const classes = useStyles();

    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {
        // Fetch the content of the markdown file from the public directory
        fetch('/AboutMarkdown.txt')
            .then((response) => response.text())
            .then((text) => {
                // Update the state with the fetched markdown content
                setMarkdownContent(text);
            })
            .catch((error) => {
                console.error('Error fetching markdown content:', error);
            });
    }, []); // The empty array ensures this effect runs only once on mount

    return (
        <div className={classes.container}>
            <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </div>
    );
};

export default About;
